// Returns initials given a set of names/words up to the maxInitials length
// returns defaultValue is there is an error, or no initials can be created

export default ({ name, defaultValue = 'CU', maxInitials = 2 } = {}) => {
  try {
    // if no name or name isn't a string then just return the default value
    if (typeof name !== 'string' || !name.trim()) return defaultValue;

    const nameArray = name.split(' ');
    const returnArray = [];
    let i = 0;

    // otherwise get the first letter of each word up to the max
    // or until there are no more words
    while (returnArray.length < maxInitials && i < nameArray.length) {
      const currentValue = nameArray[i][0];
      // if current value in name array, push it to the return array
      if (currentValue) returnArray.push(currentValue);
      i += 1;
    }

    // turn the array of initials into a string
    const returnedName = returnArray.join('');

    // if there are initial return them otherwise return the default value
    return returnedName.length ? returnedName : defaultValue;
  } catch (err) {
    // if there is an error just return default value
    return defaultValue;
  }
};
